export const addLoader = async ({ commit }) => {
  commit('addLoader');
};

export const removeLoader = async ({ commit }) => {
  commit('removeLoader');
};

export const start = async ({ commit }) => {
  commit('addLoader');
};

export const stop = async ({ commit }) => {
  commit('removeLoader');
};
